export enum UserRole {
  Admin = "ADMIN",
  Doctor = "DOCTOR",
  Staff = "STAFF",
  Deactivated = "DEACTIVATED",
}
